/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CameraProxyStatus {
    Undefined = 0,
    Available = 1,
    Unavailable = 2,
    Requested = 3,
    NoInput = 4,
}
